import React from 'react';
import Eventcontentmang from '../sections/sec-event-content-mangement';

const Contentmangementevent = () => {
    return (
        <>
                <section className='home'>
                <div className='circle-dec-sec1'></div>
                <div className='circl2-sec1-dec'></div>
                <Eventcontentmang />
        </section>
        </>
      );
}
 
export default Contentmangementevent;